import { render, staticRenderFns } from "./printViewFun.vue?vue&type=template&id=36aa4737&scoped=true&"
import script from "./printViewFun.vue?vue&type=script&lang=js&"
export * from "./printViewFun.vue?vue&type=script&lang=js&"
import style0 from "./printViewFun.vue?vue&type=style&index=0&id=36aa4737&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa4737",
  null
  
)

export default component.exports